var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.InvestorRegisteredOnSecondaryMarket)?[_c('big-title',[_vm._v(" Retirar ")]),_c('withdraw-info-sm')]:[_c('big-title',[_vm._v(" Retirar "),_c('span',[_vm._v("fondos")]),_vm._v(". ")]),_c('withdraw-info')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }